import { render, staticRenderFns } from "./ExamplesSuite.vue?vue&type=template&id=3a7f22a9&scoped=true&"
import script from "./ExamplesSuite.vue?vue&type=script&lang=ts&"
export * from "./ExamplesSuite.vue?vue&type=script&lang=ts&"
import style0 from "./ExamplesSuite.vue?vue&type=style&index=0&id=3a7f22a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7f22a9",
  null
  
)

export default component.exports